import _asyncToGenerator from "E:/meari/cloudMall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "right"
};
var _hoisted_2 = {
  class: "loginIcon"
};

var _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;"
}, "退出", -1);

var _hoisted_4 = {
  class: "toBuy"
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode(" 去购买 ");

var _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "layer"
}, null, -1);

var _hoisted_7 = {
  class: "loginBox"
};

var _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "欢迎登陆", -1);

var _hoisted_9 = {
  class: "submitBtn"
};

var _hoisted_10 = /*#__PURE__*/_createTextVNode(" 登录 ");

import { onMounted, ref, watch } from "vue";
import { showSuccessToast, showFailToast } from "vant";
import { DownOutlined, UserOutlined, LockOutlined } from "@ant-design/icons-vue";
import { singInApi, signOutApi } from "@/api";
import { useRouter } from "vue-router";
import GlobalStateService from "@/services/global";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var router = useRouter();
    var isScroll = ref(false);
    var isLogin = ref(false);
    var userInfoShow = ref(false);
    var toBuyVisible = ref(false);
    var loginForm = ref({
      username: "",
      password: ""
    });
    var userAccount = ref("");

    var loginHandle = function loginHandle() {
      GlobalStateService.state.showLogin = true;
      console.log(GlobalStateService.state.showLogin);
    };

    var onSubmit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var loginBody, loginRes;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("sumbit");
                loginBody = {
                  userAccount: loginForm.value.username,
                  password: loginForm.value.password,
                  phoneCode: "86",
                  countryCode: "CN",
                  lngType: "en"
                };
                _context.next = 4;
                return singInApi(loginBody);

              case 4:
                loginRes = _context.sent;

                if (loginRes) {
                  console.log(loginRes);
                  GlobalStateService.state.userId = loginRes.userID;
                  GlobalStateService.state.userToken = loginRes.userToken;
                  userAccount.value = loginRes.userAccount;
                  sessionStorage.setItem("userInfo", JSON.stringify(loginRes));
                  showSuccessToast("登录成功");
                  isLogin.value = true;
                  GlobalStateService.state.showLogin = false;
                } else {
                  showFailToast("登录失败");
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function onSubmit() {
        return _ref.apply(this, arguments);
      };
    }();

    var loginDialogCancel = function loginDialogCancel() {
      GlobalStateService.state.showLogin = false;
    };

    var logout = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return signOutApi();

              case 2:
                result = _context2.sent;

                if (result) {
                  showSuccessToast("登出成功");
                  userInfoShow.value = false;
                  isLogin.value = false;
                  userAccount.value = "";
                  router.push("/");
                } else {
                  showFailToast("登出失败");
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function logout() {
        return _ref2.apply(this, arguments);
      };
    }();

    var toPay = function toPay() {
      if (!isLogin.value) {
        GlobalStateService.state.showLogin = true;
        return;
      }

      router.push("productDetail");
    };

    watch(function () {
      return router.currentRoute.value.path;
    }, function (path) {
      if (path === "/productDetail") {
        toBuyVisible.value = false;
      } else {
        toBuyVisible.value = true;
      }
    }, {
      immediate: true
    });

    var back = function back() {
      router.push("/");
    };

    onMounted(function () {
      var storageUserInfo = sessionStorage.getItem("userInfo");

      if (storageUserInfo) {
        var userInfo = JSON.parse(storageUserInfo);
        GlobalStateService.state.userId = userInfo.userID;
        GlobalStateService.state.userToken = userInfo.userToken;
        userAccount.value = userInfo.userAccount;
        isLogin.value = true;
      }

      window.addEventListener("scroll", function () {
        if (window.scrollY !== 0) {
          isScroll.value = true;
        } else {
          isScroll.value = false;
        }
      });
    });
    return function (_ctx, _cache) {
      var _component_a_menu_item = _resolveComponent("a-menu-item");

      var _component_a_menu = _resolveComponent("a-menu");

      var _component_a_dropdown = _resolveComponent("a-dropdown");

      var _component_a_button = _resolveComponent("a-button");

      var _component_a_input = _resolveComponent("a-input");

      var _component_a_form_item = _resolveComponent("a-form-item");

      var _component_a_input_password = _resolveComponent("a-input-password");

      var _component_a_form = _resolveComponent("a-form");

      var _component_a_modal = _resolveComponent("a-modal");

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass("pageHeader ".concat(isScroll.value ? 'scroll' : ''))
      }, [_createElementVNode("div", {
        class: "left"
      }, [_createElementVNode("div", {
        class: "logo",
        onClick: back
      })]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!userAccount.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "loginText",
        onClick: loginHandle
      }, "登录")) : (_openBlock(), _createBlock(_component_a_dropdown, {
        key: 1
      }, {
        overlay: _withCtx(function () {
          return [_createVNode(_component_a_menu, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_menu_item, {
                onClick: logout
              }, {
                default: _withCtx(function () {
                  return [_hoisted_3];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("a", {
            class: "antDropdown",
            onClick: _cache[0] || (_cache[0] = _withModifiers(function () {}, ["prevent"]))
          }, [_createTextVNode(_toDisplayString(userAccount.value) + " ", 1), _createVNode(_unref(DownOutlined), {
            class: "antDropdownIcon"
          })])];
        }),
        _: 1
      }))]), _withDirectives(_createElementVNode("div", _hoisted_4, [_createVNode(_component_a_button, {
        type: "primary",
        size: "mini",
        color: "#14beb4",
        onClick: toPay
      }, {
        default: _withCtx(function () {
          return [_hoisted_5];
        }),
        _: 1
      })], 512), [[_vShow, toBuyVisible.value]])]), _createVNode(_component_a_modal, {
        visible: _unref(GlobalStateService).state.showLogin,
        "onUpdate:visible": _cache[3] || (_cache[3] = function ($event) {
          return _unref(GlobalStateService).state.showLogin = $event;
        }),
        footer: null,
        closable: false,
        wrapClassName: "loginDialogBox"
      }, {
        default: _withCtx(function () {
          return [_hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_a_form, {
            model: loginForm.value,
            class: "loginFormBox",
            "label-col": {
              span: 4
            },
            "wrapper-col": {
              span: 16
            },
            autocomplete: "off",
            onFinish: onSubmit
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_form_item, {
                label: "账号",
                name: "username",
                rules: [{
                  required: true,
                  message: 'Please input your username!'
                }]
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_a_input, {
                    value: loginForm.value.username,
                    "onUpdate:value": _cache[1] || (_cache[1] = function ($event) {
                      return loginForm.value.username = $event;
                    })
                  }, {
                    prefix: _withCtx(function () {
                      return [_createVNode(_unref(UserOutlined), {
                        class: "site-form-item-icon"
                      })];
                    }),
                    _: 1
                  }, 8, ["value"])];
                }),
                _: 1
              }), _createVNode(_component_a_form_item, {
                label: "密码",
                name: "password",
                rules: [{
                  required: true,
                  message: 'Please input your password!'
                }]
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_a_input_password, {
                    value: loginForm.value.password,
                    "onUpdate:value": _cache[2] || (_cache[2] = function ($event) {
                      return loginForm.value.password = $event;
                    })
                  }, {
                    prefix: _withCtx(function () {
                      return [_createVNode(_unref(LockOutlined), {
                        class: "site-form-item-icon"
                      })];
                    }),
                    _: 1
                  }, 8, ["value"])];
                }),
                _: 1
              }), _createElementVNode("div", _hoisted_9, [_createVNode(_component_a_button, {
                type: "primary",
                style: {
                  "width": "70%"
                },
                "html-type": "submit"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_10];
                }),
                _: 1
              })])];
            }),
            _: 1
          }, 8, ["model"])])];
        }),
        _: 1
      }, 8, ["visible"])], 2);
    };
  }
});